// prettier-ignore
export const Account = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" fillRule="evenodd" d="M.67 8a7.33 7.33 0 1 1 14.66 0A7.33 7.33 0 0 1 .67 8ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z" clipRule="evenodd"/>
    <path fill="currentColor" fillRule="evenodd" d="M5.67 6a2.33 2.33 0 1 1 4.66 0 2.33 2.33 0 0 1-4.66 0ZM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-1.33 5.33A2.67 2.67 0 0 0 4 12.83a.67.67 0 0 1-1.33-.1 4 4 0 0 1 4-3.73h2.66a4 4 0 0 1 4 3.73.67.67 0 1 1-1.34.09 2.67 2.67 0 0 0-2.66-2.49H6.67Z" clipRule="evenodd"/>
  </svg>
)
